<script setup>
import FilterComponent from '@/@core/components/custom/FilterComponent.vue'
import AnalyticsFeedbackTracker from '@/@core/components/feedback/AnalyticsFeedbackTracker.vue'
import CustomerCommunicationFeedbackTable from '@/views/feedback/feedback-panel/CustomerCommunicationFeedbackTable.vue'
import FeedbackDrawerV2 from '@/views/feedback/feedback-panel/drawer/FeedbackDrawerV2.vue'
import FeedbackResponseDrawer from '@/views/feedback/feedback-panel/drawer/FeedbackResponseDrawer.vue'

definePage({
  meta: {
    name: 'feedback-panel',
    subject: 'feedback.menu',
    action: 'communication',
  },
})

const feedbackFilters = ref({})

const { data: filterOptions } = await useApi(createUrl('/feedbacks/filters', {
  query: {
    type: 'customer_communication',
  },
}))

const isFeedbackDrawerVisible = ref(false)
const isFeedbackResponseDrawerVisible = ref(false)
const feedbackDrawerData = ref()
const feedbackResponseDrawerData = ref()

const showFeedback = (feedbackData, type) => {
  feedbackDrawerData.value = { ...feedbackData, drawerType: 'customer-communication' }
  isFeedbackDrawerVisible.value = true
}

const showFeedbackResponse = feedbackData => {
  feedbackResponseDrawerData.value = feedbackData
  isFeedbackResponseDrawerVisible.value = true
}

const feedbackTable = ref(null)
const feedbackTracker = ref(null)

const refreshCustomerCommunicationFeedbackTable = () => {
  feedbackTable.value?.fetchFeedbacks()
  feedbackTracker.value?.fetchStatusGraph()
}
</script>

<template>
  <section>
    <VRow class="match-height">
      <VCol
        cols="12"
        md="6"
      >
        <FilterComponent
          v-model:filters="feedbackFilters"
          :filters-options="filterOptions"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>
      <VCol
        cols="12"
        md="6"
      >
        <AnalyticsFeedbackTracker
          ref="feedbackTracker"
          class="h-100"
          :feedback-filters="feedbackFilters"
          :customer-communication="1"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>

      <VCol cols="12">
        <CustomerCommunicationFeedbackTable
          ref="feedbackTable"
          :feedback-filters="feedbackFilters"
          @show-feedback="showFeedback"
          @show-feedback-response="showFeedbackResponse"
        />
      </VCol>
    </VRow>

    <FeedbackResponseDrawer
      v-model:isDrawerOpen="isFeedbackResponseDrawerVisible"
      :feedback-data="feedbackResponseDrawerData"
    />

    <FeedbackDrawerV2
      v-model:isDrawerOpen="isFeedbackDrawerVisible"
      :feedback-data="feedbackDrawerData"
      :customer-communication="true"
      @show-feedback-response="showFeedbackResponse"
      @refresh-feedback-table="refreshCustomerCommunicationFeedbackTable"
    />
  </section>
</template>
